define.alias("shared/components/shared/wizard/slide/footer", "preview-grid/components/shared/wizard/slide/footer");